import {
  Directive,
  ElementRef,
  HostListener,
  AfterViewInit,
  Renderer2,
  OnChanges,
  SimpleChanges,
  Input
} from '@angular/core';

@Directive({
    selector: '[dfManageCardSelectable]',
    standalone: false
})
export class DfManageCardMultiselectableDirective implements AfterViewInit, OnChanges {
  private input!: HTMLElement;

  @Input() dfManageCardSelectable!: boolean;

  constructor(private readonly element: ElementRef, private readonly renderer: Renderer2) {}

  ngAfterViewInit() {
    this.input = this.element.nativeElement.querySelector('.form-check-input');
    this.renderer.setAttribute(this.input, 'tabIndex', '-1');
  }

  @HostListener('click', ['$event'])
  click(event: any) {
    const target: HTMLElement = event.target;
    // If the input or the label is clicked then the selection is already made
    // The card must have only one input
    if (!(target.classList.contains('form-check-input') || target.classList.contains('form-check-label'))) {
      this.input.click();
    } else {
      this.element.nativeElement.focus();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dfManageCardSelectable.currentValue === true) {
      this.renderer.addClass(this.element.nativeElement, 'df-card-selected');
    } else {
      this.renderer.removeClass(this.element.nativeElement, 'df-card-selected');
    }
  }
}
